import { connect } from "react-redux";
import SendEmail from "../Components/SendEmail";
import { setVisible } from "../reducers/Ui/Actions";

const mapStateToProps = ({ ui, Configuration }) => {
  const configuration = Configuration.configuration || {};
  return {
    Component: SendEmail,
    show: !!ui.visibilityMap.sendEmail,
    shareUrl: configuration.shareUrl,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(setVisible("sendEmail", false)),
  onOkClick: () => dispatch(setVisible("sendEmail", false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SendEmail);
